import * as React from "react";
import { Button } from "@mui/material";
import {
  platformPrimaryButtonSx,
  platformGhostButtonSx,
  platformDangerButtonSx,
  platformButtonSmallSx,
} from "../tickitPlatformTheme";

const variants = {
  primary: platformPrimaryButtonSx,
  ghost: { ...platformGhostButtonSx, borderWidth: 1.5 },
  danger: platformDangerButtonSx,
};

export default function PlatformButton({
  variant = "primary",
  size = "medium",
  startIcon,
  children,
  sx = {},
  ...rest
}) {
  const sizeSx = size === "small" ? platformButtonSmallSx : {};

  return (
    <Button
      variant={variant === "primary" ? "contained" : variant === "ghost" ? "outlined" : "contained"}
      startIcon={startIcon}
      sx={{ ...variants[variant], ...sizeSx, ...sx }}
      {...rest}
    >
      {children}
    </Button>
  );
}
